import ListUserGroups from '../components/ListGroups/ListUsersGroups'

const UsersPage = () => (
    <ListUserGroups />
)

export default UsersPage